// Anything shaped like an email address: no whitespace or extra "@", and a
// dot somewhere after the "@". Deliberately loose, since masking a near-miss
// in a replay costs nothing. The quantifiers are bounded (RFC 5321 lengths)
// so a long unbroken string can't make the match backtrack quadratically:
// this runs on the main thread for every recorded text node.
const EMAIL_PATTERN = /[^\s@]{1,64}@[^\s@.]{1,63}(?:\.[^\s@.]{1,63}){1,8}/g;

/** Session-replay text mask: hides email-shaped text and leaves the rest of
 *  the node readable, so replays keep the transcript and feedback they exist
 *  for. Covers text nodes only; attributes and error messages are not
 *  masked here (privacy policy, Section 7). */
export function maskEmailAddresses(text: string): string {
  if (!text.includes("@")) return text;
  return text.replace(EMAIL_PATTERN, "***");
}
